"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _String = _interopRequireDefault(require("./String"));
var _withMobile = _interopRequireDefault(require("../Hoc/withMobile.js"));
var _ChevronRight = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const drawerWidth = 340;
const useStyles = (0, _styles.makeStyles)(theme => ({
  drawerPaper: {
    zIndex: 1000 // So we are behind standard AppBars
  },
  drawerAppBarSpacer: {
    // necessary for content to be below AppBars
    display: "flex",
    alignItems: "center",
    ...theme.mixins.toolbar,
    justifyContent: "flex-end"
  },
  drawerMobile: {
    [theme.breakpoints.down("lg")]: {
      display: "block"
    },
    [theme.breakpoints.up("lg")]: {
      display: "none"
    },
    "& .MuiDrawer-paper": {
      boxSizing: "border-box",
      width: drawerWidth
    }
  },
  drawerNormal: {
    [theme.breakpoints.down("lg")]: {
      display: "none"
    },
    [theme.breakpoints.up("lg")]: {
      display: "block"
    },
    "& .MuiDrawer-paper": {
      boxSizing: "border-box",
      width: drawerWidth
    }
  }
}));

/**
 * Drawer component
 *
 * @package HOPS
 * @subpackage Ui
 * @author Carl Booth
 * @copyright Heritage Operations Processing Limited
 */
const Drawer = props => {
  const classes = useStyles();
  const handleDrawerClosed = () => {
    props.handleDrawerClosed?.();
  };
  const handleDrawerTransitionEnd = () => {
    props.handleDrawerTransitionEnd?.();
  };
  const content = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.drawerAppBarSpacer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_IconButton.default, {
        onClick: props.onClose,
        size: "large",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
          str: "Close"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronRight.default, {})]
      })
    }), props.children]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Drawer.default, {
      anchor: props.anchor,
      className: classes.drawerMobile,
      classes: {
        paper: classes.drawerPaper
      },
      open: props.open,
      onClose: handleDrawerClosed,
      onTransitionEnd: handleDrawerTransitionEnd,
      ModalProps: {
        keepMounted: true // Better open performance on mobile
      },
      variant: "temporary",
      children: content
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Drawer.default, {
      anchor: props.anchor,
      className: classes.drawerNormal,
      classes: {
        paper: classes.drawerPaper
      },
      open: true,
      variant: "permanent",
      children: content
    })]
  });
};
Drawer.defaultProps = {
  anchor: "left",
  open: false
};
Drawer.propTypes = {
  anchor: _propTypes.default.oneOf(["bottom", "left", "right", "top"]),
  open: _propTypes.default.bool,
  onClose: _propTypes.default.func
};
var _default = exports.default = (0, _withMobile.default)(Drawer);